import React from 'react';
import { Favorite } from '@/components/Favorite';
import { BlockButton } from '@/components/BlockButton';
import defaultImage from '@/assets/images/no_image_found.png';

interface ListingProps {
  signedIn: boolean;
  listingDetails: any;
  blockCallback: () => void;
  withColumn?: boolean;
  showTypeBadge?: boolean;
}

export function Listing({
  signedIn,
  listingDetails,
  blockCallback,
  withColumn = true,
  showTypeBadge = false,
}: ListingProps) {
  // start_date is a date-only "YYYY-MM-DD" string; new Date() would parse it as UTC midnight,
  // which renders as the previous day in US time zones, so build it as a local date instead.
  const [year, month, day] = String(listingDetails.start_date || '')
    .slice(0, 10)
    .split('-')
    .map(Number);
  const startDate = year && month && day ? new Date(year, month - 1, day) : null;
  const startDateText = startDate
    ? startDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
    : 'None';
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const isPastDate = startDate && startDate < today;
  const moveInText = isPastDate ? 'Available now' : startDateText;

  return (
    <div className={withColumn ? 'col mb-4' : 'h-100'}>
      <div className="card listing-card h-100">
        {(listingDetails.featured || showTypeBadge) && (
          <div className="housing-badges">
            {listingDetails.featured && (
              <a
                href={listingDetails.listing_path || listingDetails.route_path}
                target="_blank"
                className="featured badge rounded-pill bg-danger"
              >
                Featured
              </a>
            )}
            {showTypeBadge && <span className="housing-type-badge badge rounded-pill bg-success">Listing</span>}
          </div>
        )}

        <Favorite
          signedIn={signedIn}
          favoritableType="Listing"
          favoritableId={listingDetails.id}
          favorited={listingDetails.favorited}
        />

        <BlockButton
          signedIn={signedIn}
          blockableType="Listing"
          blockableId={listingDetails.id}
          blocked={listingDetails.blocked}
          blockCallback={blockCallback}
        />

        <a href={listingDetails.listing_path || listingDetails.route_path} target="_blank">
          <img
            src={listingDetails.images.length ? listingDetails.images[0].url : defaultImage}
            className="card-img-top"
            alt={listingDetails.images.length ? listingDetails.images[0].alt : listingDetails.title}
          />
        </a>
        <div className="card-body">
          <div className="card-title">
            <a href={listingDetails.listing_path || listingDetails.route_path} target="_blank">
              {listingDetails.title}
            </a>
          </div>
          <div className="card-text">
            ${listingDetails.price} / {listingDetails.beds} beds
          </div>
          <div className="card-text">{listingDetails.layout}</div>
          <div className="card-text pb-2">Move In: {moveInText}</div>
          {listingDetails.posted_at && (
            <div className="card-text text-muted">
              Posted:{' '}
              {new Date(listingDetails.posted_at * 1000).toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
